import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PercorsoVista} from '../contenitore-percorso/percorso-vista';
import {CardFase} from '../contenitore-percorso/contenitore-percorso.model';

/**
 * Feature 166, vista C: righe con contorno e tessere per fase. La fase toccata va nel footer di Info contenitore
 * (selezione tenuta da ContenitorePercorsoComponent).
 */
@Component({
  selector: 'app-contenitore-percorso-mappa',
  templateUrl: './contenitore-percorso-mappa.component.html',
  styleUrls: ['./contenitore-percorso-mappa.component.scss'],
  standalone: false
})
export class ContenitorePercorsoMappaComponent extends PercorsoVista {
  @Input() selezionata: CardFase | null = null;
  @Output() seleziona = new EventEmitter<CardFase>();
}
